import usePersistedState from 'src/hooks/globalState/usePersistedState';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import StorageKeys from 'src/lib/storage/storageKeys';
import { isSeoCrawler } from 'src/utils/seo/isSeoCrawler';
const DEFAULT_LIST_VIEW_MODE = 'split';
export function isQuestionListMasterDetail(isDesktop, listViewMode) {
    return isDesktop && listViewMode === 'split' && !isSeoCrawler;
}
export default function useListViewMode() {
    const [listViewMode, setListViewMode] = usePersistedState(StorageKeys.listViewMode, DEFAULT_LIST_VIEW_MODE);
    const isSplitView = listViewMode === 'split';
    const toggleListViewMode = useStableCallback(() => {
        setListViewMode(prev => (prev === 'split' ? 'list' : 'split'));
    });
    return {
        listViewMode,
        isSplitView,
        setListViewMode,
        toggleListViewMode,
    };
}
